import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class ToggleGuard implements CanActivate {
  enableStatus: any;
  constructor(private readonly router: Router, private readonly featureFlagService: TranslationService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.enableStatus = this.featureFlagService.featureFlags;
      const page = route.data['page']
      if(this.enableStatus.general[page]){
        return true;
      } else {
        this.router.navigateByUrl('coming-soon');
        return false;
      }
  }
  
}